
import { MapTo } from '@adobe/aem-react-editable-components';
import ReviewSingleProductModule, { ReviewSingleProductModuleEditConfig } from './ReviewSingleProductModule';

export default MapTo('cob-corp-acquisition/components/creditonebank/review-single-product-module')(ReviewSingleProductModule, ReviewSingleProductModuleEditConfig);
        